import { render, staticRenderFns } from "./Gala2026.vue?vue&type=template&id=299130a6&scoped=true&"
import script from "./Gala2026.vue?vue&type=script&lang=js&"
export * from "./Gala2026.vue?vue&type=script&lang=js&"
import style0 from "./Gala2026.vue?vue&type=style&index=0&id=299130a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299130a6",
  null
  
)

export default component.exports